import { gsap, Cubic, Quint, Circ, Expo, Linear } from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { ScrollToPlugin } from "gsap/dist/ScrollToPlugin";
import VimeoSection from "~/js/common/vimeo-section";
import Common from "~/js/common/common";
import store from "~/js/store/store";
import _each from "lodash/each";
import _pullAt from "lodash/pullAt";
import _debounce from "lodash/debounce";
import _throttle from "lodash/throttle";
import Hammer from "hammerjs";

export default class PinSection {
  constructor(options) {
    gsap.registerPlugin(ScrollTrigger);
    gsap.registerPlugin(ScrollToPlugin);
    this.scrollTween = null;
    this.multiImageTween = null;
    this.autoScrollTween = null;
    this.resizeFlg = false;
    this.triggers = [];

    this.isScrolling = false;
    this.currentIndex = 0;
    this.sectionLength = 0;
    this.options = {};
    if (options) {
      this.setupOptions(options);
    }

    this.isPanning = false;
    this.startTouchY = 0;
    this.scrollY = 0;
    this.setupSections();

    this.setupScroll();
    this.scrolling.disable();
    this.vimeoSection = new VimeoSection(false);
    this.setupScrollTriggers();
    this.setupAutoScroll();
    gsap.delayedCall(0.2, () => {
      this.setup();
      if (!this.checkAndGoToHash()) {
        this.checkNavigationType();
      }
    });
  }

  /**
   * 遷移方法による挙動
   * historyBackじゃないとき且つ、Hashがない場合はScroll処理を実行したい
   */
  checkNavigationType() {
    /*let perfEntries = performance.getEntriesByType('navigation')
    let _nav = perfEntries[0]
    if (_nav) {
      _nav.type !== "back_forward"
    }*/

    if (window.performance.navigation.type !== window.performance.navigation.TYPE_BACK_FORWARD) {
      this.goToSection(this.currentIndex, true);
    } else {
    }
  }

  setup() {
    this.tabTween;
    store.dispatch("init");
    this.unsubscribe = store.subscribe((mutation, state) => {
      if (mutation.type === "changePinScroll") {
        let _to = state.app.pinSection.to;
        this.goToSection(_to, false, true);
      } else if (mutation.type === "multiImage") {
        if (state.app.pinSection.multiImageLength) {
          this.updateMultiImage();
        } else {
          this.stopMultiImage();
        }
      } else if (mutation.type === "toggleNavi" || mutation.type === "closeNavi") {
        // menu開閉状態による挙動の調整
      } else if (mutation.type === "tabKeyDown") {
        // updateでgoToしてしまう挙動をキャンセルするために、キーダウン時にリサイズフラグをたてる
        this.resizeFlg = true;
        if (this.tabTween) {
          this.tabTween.kill();
        }
        this.tabTween = gsap.delayedCall(0.3, () => {
          this.resizeFlg = false;
        });
      } else if (mutation.type === "tabKeyUp") {
        // タブキーがおされたので、自動停止をとめる
        if (this.options) {
          this.options.autoPlay = false;
        }
        // こちらでリサイズフラグをおろしても良いかもしれないが、確実に落ちるか不安
        let target = state.app.keyboard.target;
        if (!target) {
          return;
        }
        if (target.classList.contains("js-tabsection")) {
          let to = target.getAttribute("data-to");
          if (to) {
            // タブ押下時
            //　アニメーションさせずにステータスだけ更新
            this.goToSection(parseInt(to, 10), true, false, true);
          }
        }

        if (state.app.pinSection.multiImageLength) {
          let multiIndex = target.getAttribute("data-multi-index");
          if (multiIndex !== null || multiIndex !== undefined) {
            const collections = store.getters["isDoubleCollection"];
            // タブ押下時のマルチイメージ遷移
            store.dispatch("multiImage", {
              length: collections,
              count: parseInt(multiIndex, 10)
            });
          }
        }
      } else if (mutation.type === "arrowDownKeyUp") {
        this.gotoNextScene();
      } else if (mutation.type === "arrowUpKeyUp") {
        this.gotoPrevScene();
      } else if (mutation.type === "deviceSizeChanged") {
        location.reload();
      }
    });

    this.setupWindowEvent();
  }

  setupWindowEvent() {
    window.addEventListener("resize", () => {
      // リサイズ中のフラグ
      this.resizeFlg = true;
    });

    window.addEventListener(
      "resize",
      _debounce(() => {
        // PinSectionはブレークポイントがタブレットサイズ
        if (Common.isTabletSize()) {
          this.updateSectionHeight(innerHeight);
        } else {
          this.refreshTrigger();
          this.goToSection(this.currentIndex);
        }
        this.resizeFlg = false;
      }, 1200)
    );
    this.isMouseDown = false;
    this.isTouchDown = false;
    this.isScrollbarMove = false;
    window.addEventListener("mousedown", (e) => {
      this.isMouseDown = true;
    });
    window.addEventListener("touchstart", (e) => {
      this.isTouchDown = true;
    });
    window.addEventListener("touchend", (e) => {
      this.isTouchDown = false;
    });
    window.addEventListener("mouseup", (e) => {
      this.isMouseDown = false;
      store.dispatch("registScrollEventType", {
        eventType: null
      });
      if (this.isScrollbarMove) {
        // console.log("スクロールバーで移動した");
        // console.log("インデックスへ移動 -> " + this.currentIndex);
        /*gsap.delayedCall(0.4, () => {
          this.goToSection(this.currentIndex);
        });*/
        this.isScrollbarMove = false;
      }
    });
  }

  refreshTrigger() {
    ScrollTrigger.refresh();
  }

  /**
   * おもにiOS用 sectionの高さをステータスバーに合わせて変更
   * @param h
   */
  updateSectionHeight(h) {
    const sections = this.getSections();
    const brandMain = document.querySelector("main");
    /*
    if (!store.state.app.isHome) {
      gsap.set(brandMain, {
        paddingTop: h
      });
    }
*/

    // ここで返すとリサイズフラグのみ動いてしまった場合の高さ復旧手段がなくなってしまう
    /*if (!this.resizeFlg) {
      return;
    }*/
    _each(sections, (section, index) => {
      if (section.getAttribute("data-noheight")) {
        return;
      }

      // WL追加コード：ブランドトップセクションの高さを調整
      if(section.parentElement.classList.contains('shopify-section') && !section.parentElement.classList.contains('pinfooter') ){
        gsap.to(section.parentElement, {
          height: h,
          duration: 0,
          overwrite: true
        });
      }
      gsap.to(section, {
        height: h,
        duration: 0,
        overwrite: true
      });
    });
  }

  /**
   * 移動前の位置に瞬時に移動
   * iOS17で不具合がありこの処理はスマホのみスキップする
   * @param to
   */
  setToPrevPos(to) {
    // iOS17で不具合がありこの処理はスマホのみスキップする
    if (Common.isTabletSize()) {
      return;
    }
    gsap.to(window, {
      duration: 0,
      scrollTo: {
        y: to,
        autoKill: false
      },
      overwrite: true
    });
  }

  /**
   * Options
   * @param options
   */
  setupOptions(options) {
    if (options.autoPlay) {
      this.options.autoPlay = true;
    }
  }

  setupSections() {
    //homeと差別化
    const home = document.getElementById("home");
    if(home){
      var parentElem = document.querySelector("main section");
      while (parentElem.firstChild) {
        parentElem.parentNode.insertBefore(parentElem.firstChild, parentElem);
      }
        // 空の親要素を削除
      parentElem.parentNode.removeChild(parentElem);

      //　ドットタグの位置をheader直下に移動
      const side_nav = document.querySelector(".l-sidenavi");
      const header     = document.getElementById("shopify-section-header");
      document.body.insertBefore(side_nav,header.nextSibling);

      //　footerの位置をmain内に移動
      document.getElementById("shopify-section-footer").remove()
      const main = document.querySelector("#main .home");
      const footer = document.querySelector(".pinfooter");
      if(footer)main.appendChild(footer);
    }else{

      //　ドットタグの位置をheader直下に移動
      const side_nav = document.querySelector(".l-sidenavi");
      const header     = document.getElementById("shopify-section-header");
      document.body.insertBefore(side_nav,header.nextSibling);

      document.getElementById("shopify-section-footer").remove()
      const main = document.querySelector("#main");
      const footer = document.querySelector(".pinfooter");
      if(footer)main.appendChild(footer);
    }

    let _sections = this.getSections();
    _each(_sections, (elm, index) => {
      elm.id = "section" + index;
      if (Common.isTabletSize()) {
        this.removeElm(elm.querySelectorAll(".pc"));
      } else {
        this.removeElm(elm.querySelectorAll(".sp"));
      }
      let _tabsections = elm.querySelectorAll(".js-tabsection");
      _each(_tabsections, (tabsection) => {
        tabsection.setAttribute("data-to", index);
      });
    });
  }

  removeElm(elms) {
    _each(elms, (elm) => {
      elm.remove();
    });
  }

  setupAutoScroll() {
    this.stopAutoScroll();
    let _sections = this.getSections();
    let defaultTime = 0;
    if (_sections.length - 1 <= this.currentIndex) {
      defaultTime = 1;
    }

    // auto オートプレイ無効時はreturn
    //return;
    if (this.options && this.options.autoPlay) {
      let autoplayObj = {
        time: defaultTime
      };
      this.autoScrollTween = gsap.to(autoplayObj, {
        time: 1,
        duration: 8,
        ease: Linear.easeNone,
        onUpdate: () => {
          store.dispatch("pinSectionAutoplayTime", {
            time: autoplayObj.time
          });
        },
        onComplete: () => {
          if (!store.getters["isMenuOpen"] && !store.getters["isModalOpen"]()) {
            this.gotoNextScene();
          } else {
            this.setupAutoScroll();
          }
        }
      });
    } else {
      store.dispatch("pinSectionAutoplayTime", {
        time: 1
      });
    }
  }

  /**
   * Hashの有無を確認し、あれば該当箇所へ移動
   */
  checkAndGoToHash() {
    const hash = location.hash.replace("#", "");
    let result = false;
    if (hash) {
      let _sections = this.getSections();
      _each(_sections, (section, index) => {
        if (section.id === hash) {
          //if (section.id.search(hash) !== -1) {
          this.goToSection(index, true);
          result = true;
        }
      });
    }
    return result;
  }

  stopAutoScroll() {
    if (this.autoScrollTween) {
      this.autoScrollTween.kill();
      this.autoScrollTween = null;
    }
  }

  /**
   * 次のシーン（あれば）へ移行
   */
  gotoNextScene() {
    if (this.currentIndex + 1 >= this.sectionLength) {
      return;
    }
    this.goToSection(this.currentIndex + 1);
  }
  gotoPrevScene() {
    if (this.currentIndex - 1 < 0) {
      return;
    }
    this.goToSection(this.currentIndex - 1);
  }

  setupHammer() {
    if (!this.tag) {
      this.tag = document.body;
    }
    this.hammer = new Hammer(this.tag);
    // this.tag = this.tag == document.body ? document.querySelector("#main") : document.body;
    this.hammer.get("pan").set({
      threshold: 20,
      direction: Hammer.DIRECTION_VERTICAL
    });
    this.hammer.domEvents = true;
    this.hammer.on(
      "pan",
      //_debounce((e) => {
      (e) => {
        if (this.isScrolling) {
          return;
        }
        if (e.isFinal) {
          this.updateScrolls(e, true);
        }
      }
      //}, 540)
    );
  }

  // スクロール制御
  setupScroll() {
    this.setupHammer();
    this.scrolling = {
      enabled: true,
      events: "scroll,wheel,touchmove".split(","), //pointermove
      prevent: (e) => {
        if (this.isScrolling) {
          e.preventDefault();
          if (e.cancelable) {
            e.stopPropagation();
          }
          let scrollOffsetY = window.pageYOffset;
          window.scrollTo(0, scrollOffsetY);
          return;
        }
        if (e.type === "wheel") {
          this.updateScrolls(e);
        }
        if (e.type === "scroll") {
          // console.log("直前のイベント：" + store.state.pin.eventType);
          // 直前のイベントがスクロールによるものだったら？ スクロール時のcurrent更新処理 -> なにもしない
          if (store.state.pin.eventType === "scroll") {
            e.preventDefault();
            e.stopPropagation();
          }
        }
        store.dispatch("registScrollEventType", {
          eventType: e.type
        });
      },
      disable() {
        if (this.enabled) {
          this.enabled = false;
          // window.addEventListener("scroll", gsap.ticker.tick, { passive: true });

          this.events.forEach((e, i) => {
            window.addEventListener(
              e,
              (event) => {
                if (!this.enabled) {
                  this.prevent(event);
                }
              },
              { passive: false }
            );

            /*document.addEventListener(
              e,
              (event) => {
                if (!this.enabled) {
                  this.prevent(event);
                }
              },
              { passive: false }
            );*/
          });
        }
      },
      enable() {
        if (!this.enabled) {
          this.enabled = true;
          ////window.removeEventListener("scroll", gsap.ticker.tick);
          this.events.forEach((e, i) => {
            document.removeEventListener(e, this.prevent);
            window.removeEventListener(e, this.prevent);
          });
        }
      }
    };
  }

  /**
   * Deltaを確認してセクション移動を実行
   * @param e
   * @param isReverse
   */
  updateScrolls(e, isReverse = false) {
    const target = e.target;
    // 条件によっては通常スクロールをさせる

    if (store.getters["isMenuOpen"] || store.getters["isModalOpen"]()) {
      return;
    }
    //// noscrollはスキップ
    if (target && target.classList && target.classList.contains("js-noscroll")) {
      return;
    }
    
    if (!e.deltaY) {
      //-> 通常スクロールは全て不要
      return;
    }
    // deltaYが存在する = wheel, panの場合
    const deltaY = e.deltaY * (isReverse ? -1 : 1);
    if (deltaY > 1) {
      // 下スワイプ
      if (this.sectionLength - 1 > this.currentIndex) {
        this.goToSection(Math.min(this.currentIndex + 1, this.sectionLength));
        e.preventDefault();
        if (e.stopPropagation) {
          e.stopPropagation();
        }
      } else {
        // フッターではpanイベントはスキップしたい
        // -> 仕様変更によりフッターでもPANする
        /*if (e.type === "pan") {
          e.preventDefault();
        }*/
      }
    } else if (deltaY < -1) {
      // 上スワイプ
      let condition = this.sectionLength - 1 > this.currentIndex;

      // トップではフッター以下、下層ではその他リンク以下は通常スクロール
      if (condition) {
        e.preventDefault();
        if (this.currentIndex !== 0) {
          this.goToSection(Math.max(this.currentIndex - 1, 0));
        }
        if (e.stopPropagation) {
          e.stopPropagation();
        }
      } else {
        // フッターが内部スクロールしていない場合はもどる
        if (!store.state.app.pinSection.footerScrolled) {
          e.preventDefault();
          if (e.stopPropagation) {
            e.stopPropagation();
          }
          this.goToSection(Math.max(this.currentIndex - 1, 0));
        }
      }
    } else {
      e.preventDefault();
      if (e.stopPropagation) {
        e.stopPropagation();
      }
    }
  }

  // トリガー設定 ===============
  setupScrollTriggers() {
    const sections = this.getSections();
    this.sectionLength = sections.length;
    this.triggers = [];
    store.dispatch("setupPinSection", {
      length: sections.length
    });
  }

  choiceAppear(index, section, prevIndex, isShort) {
    let _bg = section.querySelector(".section__background");
    if (_bg) {
      // PIN前、あらわれるときの背景アニメーション
      this.appear(section, _bg, index, prevIndex, isShort);
    }
  }

  appear(section, bg, index, prevIndex, isShort) {
    const diff = index - prevIndex;
    const header = document.querySelector(".l-header");
    let ease = store.state.app.isHome ? Circ : Cubic; // Circ Linear
    let fromY = store.state.app.isHome ? -header.offsetHeight || -90 : 0;
    let toY = 0;
    if (diff > 0) {
      // 下
      gsap.fromTo(
        bg,
        {
          y: fromY
        },
        {
          y: 0,
          ease: ease.easeOut,
          delay: isShort ? 0 : 0.6,
          duration: isShort ? 0 : 0.3
        }
      );
    } else {
      // 上
      fromY = -fromY;
      gsap.fromTo(
        section,
        {
          y: fromY
        },
        {
          y: 0,
          ease: ease.easeOut,
          delay: isShort ? 0 : 0.6,
          duration: isShort ? 0 : 0.4,
          overwrite: true
        }
      );
    }
  }

  // Normal Appear
  normalAppear(section, bg) {
    const header = document.querySelector(".l-header");
    let ease = store.state.app.isHome ? Circ : Cubic; // Circ Linear
    let y = store.state.app.isHome ? -header.offsetHeight || -90 : 0;
  }

  /**
   * 該当セクションへ移動する
   * @param i
   * @param isShort 早い動きで遷移する。tab用 => スクロールバーでも動いてしまっている模様
   */
  goToSection(i, isShort = false, useSideNavi = false, useTabkey = false) {
    const prevIndex = this.currentIndex;
    if (!this.isScrolling) {
      this.stopAutoScroll();
      const sections = this.getSections();
      let _nextSection;
      this.isScrolling = true;
      this.currentIndex = i;

      if (this.photoSectionTween) {
        this.photoSectionTween.kill();
      }
      _each(sections, (elm, index) => {
        elm.classList.remove("active");
        if (index === this.currentIndex) {
          _nextSection = elm;
          this.vimeoSectionPlay(elm);
          this.photoSectionPlay(elm);
        } else {
          this.vimeoSectionPause(elm);
        }
      });

      store.dispatch("beforeScroll", {
        prev: prevIndex,
        next: this.currentIndex,
        section: _nextSection
      });
      let _delay = Common.isTabletSize() ? 0.01 : 0.04;

      gsap.delayedCall(_delay, () => {
        this.choiceToScroll(i, _nextSection, prevIndex, isShort, useSideNavi, useTabkey);
        this.choiceAppear(i, _nextSection, prevIndex, isShort);
      });
    }
  }

  // スクロールアニメーションの選択（結果的にnormalしか使わない仕様）
  choiceToScroll(index, section, prevIndex, isShort, useSideNavi, useTabkey) {
    if (!section) {
      return;
    }
    let h = innerHeight;
    this.updateSectionHeight(h);
    this.animateScroll(index, prevIndex, h, isShort, useSideNavi, useTabkey);
  }

  // 通常スクロールアニメーション
  animateScroll(index, prevIndex, h, isShort, useSideNavi, useTabkey) {
    // マウスダウンとscroll でスクロールバーと判定
    if (store.state.pin.eventType === "scroll" && this.isMouseDown) {
      this.isScrollbarMove = true;
      this.afterAnimation();
      return;
    }
    let delay = 0;
    let duration = 0.9;
    if (this.resizeFlg) {
      delay = 0.4;
      duration = 0.5;
      //すばやく上下させるとリサイズではないがサイズがかわるパターンもでてしまうため、ここでprevIndexへ移動させてはいけない。
    }
    // tab経由や直接飛びたい場合はfrom移動をスキップさせる
    if (isShort) {
      delay = 0;
      duration = 0; //0.05;
    } else {
      // 通常スクロール時はスキップする
      if (store.state.pin.eventType !== "scroll") {
        this.setToPrevPos(prevIndex * h);
      }
    }

    gsap.delayedCall(delay, () => {
      const sections = this.getSections();
      const target = document.querySelector("main"); // window
      const _to = document.querySelector("#s" + index);
      let _next = 0;
      _each(sections, (section, _index) => {
        if (_index < index) {
          _next += section.getBoundingClientRect().height;
        }
      });
      this.scrollTween = gsap.to(target, {
        duration: duration,
        ease: Circ.easeInOut,
        y: Math.round(-_next),
        onComplete: () => {
          this.changeActive();
          this.afterAnimation(isShort, _next);
          this.isScrolling = false;
          // サイドナビクリック時はアンカーリンクもさせて次のタブターゲットを変えたい
          //if ((useSideNavi && !Common.isTabletSize()) || useTabkey) {
          if (!Common.isTabletSize()) {
            location.hash = "section" + index;
          }
          if (useTabkey) {
            //キーボードターゲットに瞬時にフォーカスをあてることで、ブラウザがフォーカスする際におこなうスクロールをキャンセルしている、、もっと良い方法がある気がする
            let _target = store.state.app.keyboard.target;
            if (_target) {
              _target.focus();
            }
          }
        },
        overwrite: true
      });
    });
  }

  changeActive() {
    const sections = this.getSections();
    _each(sections, (elm, index) => {
      if (index === this.currentIndex) {
        elm.classList.add("active");
      }
    });
  }

  getSections() {
    let sections = [...document.querySelectorAll(".js-section")];
    let result = sections;
    _each(sections, (section, index) => {
      let onlySp = !!section.getAttribute("data-onlysp");
      if (onlySp && !Common.isTabletSize()) {
        result = _pullAt(sections, index);
      }
    });
    return sections;
  }

  // After
  afterAnimation(isShort = false, y = 0) {
    // 慣性があるとき2度はしってしまう問題を回避
    // SPは無効時間が長すぎるとiOSで上・下動作をすばやくやるとナビバーサイズが変わるので挙動がおかしくなりがち
    let pcDelay = 0.5;
    if (isShort) {
      pcDelay = 0.1;
    }
    this.refreshTrigger();
    gsap.delayedCall(Common.isTabletSize() ? 0.2 : pcDelay, () => {
      this.scrollTween = null;
      this.isScrolling = false;
    });
    store.dispatch("afterScroll", {
      y: y
    });
    this.setupAutoScroll();
  }

  // Multi Image Section =============
  updateMultiImage() {
    if (this.multiImageTween) {
      this.stopMultiImage();
    }
    this.changeMultiImage();
  }

  changeMultiImage() {
    let current = store.state.app.pinSection.multiImageCount;
    const total = store.state.app.pinSection.multiImageLength;
    this.execChangeMultiImage(current);
    let obj = {
      time: 0
    };
    this.multiImageTween = gsap.to(obj, {
      time: 1,
      duration: 5,
      ease: Linear.easeNone,
      onUpdate: () => {
        store.dispatch("multiImageTime", {
          time: obj.time
        });
      },
      onComplete: () => {
        let next = current + 1;
        if (next >= total) {
          next = 0;
        }
        store.dispatch("multiImage", {
          length: total,
          count: next
        });
      }
    });
  }

  // 表示情報を差し替える
  execChangeMultiImage(next) {
    const section = store.state.app.pinSection.nextSection;
    const sections = section.querySelectorAll(".js-multiimage");
    const nextSection = sections[next];

    if (!nextSection) {
      this.stopMultiImage();
      return;
    }
    _each(sections, (elm) => {
      elm.classList.add("hide");
    });

    store.dispatch("beforeMultiImageChange", {
      num: next,
      color: nextSection.classList.contains("white") ? "white" : ""
    });
    nextSection.classList.remove("hide");
  }

  stopMultiImage() {
    if (this.multiImageTween) {
      this.multiImageTween.kill();
      this.multiImageTween = null;
    }
  }

  // Video Photo Effects =============
  // Photo effect
  photoSectionPlay(elm) {
    if (!store.state.app.isHome) {
      return;
    }
    const vimeoSection = elm.querySelector(".js-vimeo-section");
    const image = elm.querySelector(".section__background img");
    if (elm && !vimeoSection && image) {
      this.photoSectionTween = gsap.fromTo(
        image,
        {
          scale: 1.05
        },
        {
          duration: 5,
          delay: 0.4,
          scale: 1.0,
          ease: Linear.easeNone
        }
      );
    }
  }

  // Vimeo Play
  vimeoSectionPlay(elm) {
    if (this.vimeoPlayTween) {
      this.vimeoPlayTween.kill();
      this.vimeoPlayTween = null;
    }
    const vimeoSections = elm.querySelectorAll(".js-vimeo-section");
    if (elm && vimeoSections.length) {
      vimeoSections.forEach((_vimeoSection) => {
        const player = this.vimeoSection.getVimeoPlayer(_vimeoSection);
        if (player) {
          player.setMuted(true);
          let promise = player.pause();
          promise.then(() => {
            // パフォーマンス向上のためアニメーション中は動画再生しないようにする
            this.vimeoPlayTween = gsap.delayedCall(0.9, () => {
              promise = player.play();
            });
          });
        }
      });
      /*const player = this.vimeoSection.getVimeoPlayer(vimeoSection);
      if (player) {
        player.setMuted(true);
        let promise = player.pause();
        promise.then(() => {
          // パフォーマンス向上のためアニメーション中は動画再生しないようにする
          this.vimeoPlayTween = gsap.delayedCall(0.9, () => {
            promise = player.play();
          });
        });
      }*/
    }
  }
  // Vimeo Pause
  vimeoSectionPause(elm) {
    const vimeoSections = elm.querySelectorAll(".js-vimeo-section");
    if (elm && vimeoSections.length) {
      vimeoSections.forEach((_vimeoSection) => {
        const player = this.vimeoSection.getVimeoPlayer(_vimeoSection);
        if (player) {
          player.setMuted(true);
          let promise = player.pause();
          promise.then(() => {});
        }
      });
    }
  }
}